import { __awaiter, __rest } from '../_virtual/_tslib.js';
import { searchUsingPlacesAPI } from '../_services/city-search.service.js';
import { IP_DATA_KEY, COOKIES, DefaultCookieOptions } from '../constants/misc.js';
import { toast } from '../components/toast/toast.js';
import { Cookies } from 'react-cookie';

function getSavedLoc() {
    const cookies = new Cookies();
    const savedLocString = cookies.get(COOKIES.currentLoc);
    if (!savedLocString) {
        return;
    }
    const { time } = savedLocString, savedLoc = __rest(savedLocString, ["time"]);
    if (time + 1.5 * 60 * 60 * 1000 < Date.now()) {
        return;
    }
    return savedLoc;
}
function getCurrentLocation(showToastOnFailure = true, option) {
    return __awaiter(this, void 0, void 0, function* () {
        const cookies = new Cookies();
        try {
            const savedLoc = getSavedLoc();
            if (savedLoc) {
                return {
                    city: savedLoc.city,
                    name: savedLoc.description,
                    description: savedLoc.description,
                    state: savedLoc.state,
                    place_id: savedLoc.place_id
                };
            }
            const locDataRes = yield fetch(`https://api.ipdata.co?api-key=${IP_DATA_KEY}`);
            if (locDataRes.status === 200) {
                const locData = yield locDataRes.json();
                const currLocArray = yield searchUsingPlacesAPI(locData.city, Object.assign(Object.assign({}, option), { suppressErrorToast: true }));
                if (currLocArray.length !== 0) {
                    cookies.set(COOKIES.currentLoc, JSON.stringify(Object.assign(Object.assign({}, currLocArray[0]), { time: Date.now() })), Object.assign(Object.assign({}, DefaultCookieOptions), { maxAge: 24 * 60 * 60 }));
                    return Object.assign(Object.assign({}, currLocArray[0]), { name: currLocArray[0].description });
                }
            }
            else {
                const error = {
                    code: 403,
                    message: "An error occurred. Please try searching for your location."
                };
                throw error;
                // throw "An error occurred. Please try searching for your location.";
            }
        }
        catch (e) {
            showToastOnFailure && toast.error(e.message);
            return { status: "failed" };
        }
    });
}

export { getCurrentLocation };
//# sourceMappingURL=getCurrentLocation.js.map
